var _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.7606 6.12296C16.1044 6.12201 15.4754 5.86084 15.0115 5.39674C14.5477 4.93264 14.2868 4.30351 14.2862 3.64733V0.212891H3.22924C2.37279 0.212891 1.55142 0.553108 0.945825 1.15871C0.340225 1.76431 0 2.58569 0 3.44213V22.9088C0.00127182 23.7644 0.342054 24.5845 0.947516 25.1891C1.55298 25.7937 2.37362 26.1332 3.22924 26.1332H16.5026C17.3582 26.1332 18.1789 25.7937 18.7843 25.1891C19.3898 24.5845 19.7306 23.7644 19.7318 22.9088V6.12296H16.7606Z",
    fill: "#FF3E4C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7308 6.12296H16.7596C16.1034 6.12201 15.4744 5.86084 15.0105 5.39674C14.5467 4.93264 14.2858 4.30351 14.2852 3.64733V0.212891L19.7308 6.12296Z",
    fill: "#FF3E4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86537 18.5154C9.4618 18.5147 9.07495 18.354 8.7897 18.0686C8.50444 17.7831 8.34407 17.3961 8.34375 16.9925V15.4697H11.3882V16.9925C11.3879 17.3963 11.2273 17.7835 10.9418 18.069C10.6563 18.3545 10.2691 18.515 9.86537 18.5154ZM9.12256 16.2485V16.9925C9.12256 17.1897 9.20078 17.3787 9.34005 17.5182C9.47932 17.6577 9.66825 17.7362 9.86537 17.7366C10.0626 17.7362 10.2516 17.6578 10.3911 17.5183C10.5306 17.3788 10.6091 17.1898 10.6094 16.9925V16.2485H9.12256Z",
    fill: "#FF3E4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34077 15.4707H9.86719V13.9443H8.34077V15.4707Z",
    fill: "#FF3E4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86433 13.9463H11.3907V12.4199H9.86433V13.9463Z",
    fill: "#FF3E4C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34077 12.4209H9.86719V10.8945H8.34077V12.4209Z",
    fill: "#FF3E4C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86433 10.8955H11.3907V9.36909H9.86433V10.8955Z",
    fill: "#FF3E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/ZIP.1e8dba9ee57896eeeeff19a9c89c11e2.svg";
export { ForwardRef as ReactComponent };